import React, { useContext, useRef } from 'react';
import { Popover } from 'antd';
import ChevronDown from 'assets/svg/ChevronDown';
import CloseFilled from 'assets/svg/CloseFilled';
import { FilterContextData } from 'contexts/FilterContext';
import { TierMultiSelectionPanel, TierSingleSelectionPanel } from 'components/organism/TierFilter';
import FilterV2Chip from './FilterV2Chip';

interface Props {
    attributeTypeExpandClose: any;
    setAttributeTypeExpandClose: any;
}

export const TIER_FILTER_EXPAND_KEY = 'tierFilter';

function FilterV2TierRow({ attributeTypeExpandClose, setAttributeTypeExpandClose }: Props) {
    const {
        profitPoolTierList,
        tempMultiSelectedTiers,
        tempSingleSelectedTier,
        setTempMultiSelectedTiers,
        setTempSingleSelectedTier,
        isTiersSingleSelect,
    } = useContext(FilterContextData);

    const dropdownRef = useRef<HTMLDivElement>(null);
    const isExpanded = attributeTypeExpandClose === TIER_FILTER_EXPAND_KEY;
    const selectedTiers = isTiersSingleSelect ? tempSingleSelectedTier : tempMultiSelectedTiers;

    const tierName = (tierReference: string) =>
        profitPoolTierList.find((tier: any) => tier.tierReference === tierReference)?.tierName;

    return (
        <div className="px-4 py-4 border-b border-filterV2Border">
            <Popover
                trigger={[]}
                showArrow={false}
                open={isExpanded}
                overlayInnerStyle={{ width: '250px' }}
                placement="bottomLeft"
                overlayClassName="popover-padding-remove filter-v2-card"
                content={
                    <div className="p-4">
                        <div className="flex justify-between items-center mb-3">
                            <span className="font-sm font-medium text-filterV2TextPrimary">Choose Tiers</span>
                            <span
                                className="w-[22px] h-[22px] flex justify-center items-center cursor-pointer"
                                onClick={() => setAttributeTypeExpandClose('')}
                            >
                                <CloseFilled />
                            </span>
                        </div>
                        {isTiersSingleSelect ? (
                            <TierSingleSelectionPanel
                                localSingleSelectedTier={tempSingleSelectedTier}
                                setLocalSingleSelectedTier={setTempSingleSelectedTier}
                                dropdownRef={dropdownRef}
                                profitPoolTierList={profitPoolTierList}
                            />
                        ) : (
                            <TierMultiSelectionPanel
                                localMultiSelectedTiers={tempMultiSelectedTiers}
                                setLocalMultiSelectedTiers={setTempMultiSelectedTiers}
                                dropdownRef={dropdownRef}
                                profitPoolTierList={profitPoolTierList}
                            />
                        )}
                    </div>
                }
            >
                <div
                    className="flex justify-between items-center cursor-pointer font-xs font-medium leading-[21px] text-filterV2TextPrimary"
                    onClick={() =>
                        setAttributeTypeExpandClose((oldValue: String) =>
                            oldValue == TIER_FILTER_EXPAND_KEY ? '' : TIER_FILTER_EXPAND_KEY,
                        )
                    }
                >
                    <span>Tier Filter</span>
                    <span className="flex shrink-0">
                        <ChevronDown direction={isExpanded ? 'up' : 'down'} />
                    </span>
                </div>
            </Popover>
            {selectedTiers?.length > 0 && (
                <div className="mt-2 flex flex-wrap gap-2">
                    {selectedTiers.map((tierReference: string) => (
                        <FilterV2Chip key={tierReference} label={tierName(tierReference)} />
                    ))}
                </div>
            )}
        </div>
    );
}

export default FilterV2TierRow;
